<div class="content">
    @if (!haveSameTimezoneFlag && !isLoading) {
        <p>Comparing Data Point with different time zones is not allowed, please assign a customer and site to view
            data.</p>
    }

    @if (haveSameTimezoneFlag) {
        <div class="flex flex-column">
            <div class="flex flex-row justify-content-between p-4">
                @if (!config.data.showPreview) {
                    <div class="calendar-wrapper">
                        <span class="cbms-margin-right"><strong>Filter by time</strong></span>
                        <p-datepicker
                            [class]="'telemetry-dialog'"
                            #calendar
                            [(ngModel)]="rangeDates"
                            selectionMode="range"
                            dateFormat="dd.mm.yy"
                            [maxDate]="maxDateValue"
                            [readonlyInput]="true"
                            placeholder="Select range"
                            (onSelect)="onIntervalSelected($event)"
                        >
                            <p-header>
                                <div
                                    style="
                                    padding: 0 0 10px 0;
                                    margin: 0 0 10px 0;
                                    border-bottom: 1px #404040 solid;
                                "
                                    class="flex flex-row align-items-center gap-3"
                                >
                                    <p-select
                                        [options]="timeOptionList"
                                        [(ngModel)]="selectedTime"
                                        optionLabel="label"
                                        placeholder="Select Time"
                                        (onChange)="onIntervalOptionSelected()"
                                    >
                                    </p-select>
                                    <button
                                        pButton
                                        class="p-button-raised p-button-text button-turquoise-bg"
                                        (click)="onFilter(); calendar.toggle()"
                                    >
                                        Apply
                                    </button>
                                </div>
                            </p-header>
                        </p-datepicker>
                    </div>
                }

                <div class="legend">
                    <ul class="radio-btn-group">
                        <li>
                            <span class="cbms-margin-right">Display:</span>
                        </li>
                        <li>
                            <p-radioButton
                                class="cbms-margin-right"
                                name="legendField"
                                value="objectName"
                                inputId="'dpName'"
                                [(ngModel)]="selectedlegendField"
                                (onClick)="updateGraphLegend()"
                            ></p-radioButton>
                            <label for="dpName">Datapoint Name</label></li>
                        <li>
                            <p-radioButton
                                class="cbms-margin-right"
                                name="legendField"
                                value="description"
                                inputId="'description'"
                                [(ngModel)]="selectedlegendField"
                                (onClick)="updateGraphLegend()"
                            ></p-radioButton>
                            <label for="description">Description</label>
                        </li>
                        <li>
                            <p-radioButton
                                class="cbms-margin-right"
                                name="legendField"
                                value="customName"
                                inputId="'customName'"
                                label="Custom Name"
                                [(ngModel)]="selectedlegendField"
                                (onClick)="updateGraphLegend()"
                            ></p-radioButton>
                            <label for="customName">Custom Name</label>
                        </li>
                    </ul>
                    <ul class="normal-btn-group">
                        <li>

                            <button
                                pButton
                                class="cbms-margin-right p-button-raised button-turquoise-bg"
                                (click)="selectAllSeries()"
                            >
                                Select All Data Points
                            </button>
                        </li>
                        <li>
                            <button
                                pButton
                                class="cbms-margin-right p-button-raised button-turquoise-bg"
                                (click)="deselectAllSeries()"
                            >
                                Deselect All Data Points
                            </button>
                        </li>
                        <li>
                            <button
                                pButton
                                class="cbms-margin-right p-button-raised button-turquoise-bg"
                                (click)="resetZoom()"
                                [disabled]="shouldDisableZoom()"
                            >
                                Reset Zoom
                            </button>
                        </li>
                        <li>
                            <button
                                pButton
                                class="p-button-raised p-button-text button-turquoise-bg"
                                (click)="zoomOut()"
                                [disabled]="shouldDisableZoom()"
                            >
                                <i class="pi pi-search-minus"></i>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="cbms-spinner-wrapper">
                @if (timeseries === null && !isLoading) {
                    <span>No data in specified time window</span>
                }
                @if (isLoading) {
                    <mat-spinner
                        [diameter]="30"
                        class="cbms-spinner"
                    ></mat-spinner>
                }
            </div>

            <div class="highchart-wrapper px-3">
                <div class="chart-nav">
                    <i class="pi pi-angle-left" (click)="moveChartToLeft()"></i>
                </div>
                <div style="flex-grow: 1;">
                    @if (timeseries != null && timeseries.data.length > 0) {
                        <cc-timeseries-chart
                            #chart
                            [chartConfig]="timeseries"
                            [timezone]="siteTimezone"
                        >
                        </cc-timeseries-chart>
                    }
                </div>
                <div class="chart-nav">
                    <i class="pi pi-angle-right" (click)="moveChartToRight()"></i>
                </div>
            </div>
        </div>
    }
</div>

<div class="footer">
    <button
        pButton
        class="p-button-raised p-button-text button-turquoise-bg"
        (click)="close()"
    >
        Close
    </button>
</div>
